module.exports = __webpack_public_path__ + "img/1b05e1d5fd56182e60c301d30381fba4.54901e2a.png";